module.exports = __webpack_public_path__ + "img/olympic-lacrosse.bf1f25ab.png";